<template>
    <div id="documentation-container">
        <div id="documentation-header">
            <h1>{{this.pageTopic}}</h1>
        </div>
        <div id="DocuBreak-list-container">
            <DocuBreak v-for="DocuObject in commandArray" :key="hashCode(DocuObject.description)"
                       :title="DocuObject.title"
                       :command-string="DocuObject.commandString"
                       :description="DocuObject.description"
                       :parameters="DocuObject.parameters"
                       :examples="DocuObject.examples"
                       :shortcuts="DocuObject.shortcuts"
                       :id="'cpr-' + DocuObject.routerRef"
            />
        </div>
        <div v-if="showFloatingMessage"  id="floating-message">
            <span
                style="font-size: 15px; font-weight: bold; margin-right: 0.2rem;"
                v-on:click="openSponsor()"
            >
                Join OFB Premium
            </span>
            <v-btn
                icon
                x-small
                v-on:click="showFloatingMessage = !showFloatingMessage"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
    </div>
</template>


<script>
import DocuBreak from "./sub-components/DocuBreak"
import {ALL_COMMANDS} from "../commands/CommandExports";

const commandMap = {}
for (let commandPackage of ALL_COMMANDS) {
    commandMap[commandPackage.navTitle.replace(" ", "")] = commandPackage.commandList
}

export default {
    name: 'Template',

    props: {
        topic: String,
        goToReference: String
    },

    created() {

        // When a menu item is clicked, this.topic will be passed and this code will be ran
        if (this.topic in commandMap){
            this.pageTopic = this.topic
            this.commandArray = commandMap[this.topic];
        }

        // When someone navigates to www.domain.com/documentations/x directly, this code will be ran
        else if (this.$router.currentRoute.name in commandMap) {

            this.pageTopic = this.$router.currentRoute.name.replace("Docs", "")
            this.commandArray = commandMap[this.$router.currentRoute.name.replace("Docs", "")];
        }

        // When someone navigates to www.domain.com/documentations/x/command directly, this code will be ran
        else {
            this.commandArray = commandMap[this.$router.currentRoute.name.replace("Docs", "")];
        }
    },

    mounted() {

        let commandPageReferencePrefix = "#cpr-"
        if (this.goToReference != null){
            this.$vuetify.goTo(commandPageReferencePrefix + this.goToReference, {
                duration: 850,
                offset: 100,
                easing: "easeInOutCubic",
            })
        } else {
            window.scrollTo(0,0);
        }
    },
    
    components: {
        DocuBreak
    },

    methods: {
        openSponsor: function (){
            this.$router.push({name: "LandingMain"});
        },

        hashCode: function (toHash) {
            let hash = 0;
            if (toHash.length === 0) {
                return hash;
            }
            for (let i = 0; i < toHash.length; i++) {
                let char = toHash.charCodeAt(i);
                hash = ((hash<<5)-hash)+char;
                hash = hash & hash;
            }

            return hash;
        }
    },

    data: () => ({
        commandArray: null, // If set to any specific COMMANDS it will work i.e. STOCK_COMMANDS
        pageTopic: "",
        showFloatingMessage: true
    }),
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1 {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    #documentation-container {
        padding: 0 20px;
        -ms-overflow-style: none;
    }

    #DocuBreak-list-container {
        height: 100%;
        width: 100%;
    }

    #floating-message {
        position: fixed;
        height: fit-content;
        width: fit-content;
        padding: 5px 15px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 25px;
        background-color: #4092cd;

        box-shadow: 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12), 0 3px 5px -1px rgba(0,0,0,0.20);

        z-index: 10;
        bottom: 1rem;

        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        cursor: pointer;
    }

    @media screen and (min-width: 750px) {
        #documentation-container {
            width: 50%;
            max-width: 1000px;
            margin: auto;
        }
    }

</style>
